import React from 'react';
import { Form, Select } from 'antd';
import '../../../assets/sass/_form-element.scss';
import IconFlag, { ICON } from '@/components/common/icon/iconFlag';

export default function CustomSelect({
  editMode = true,
  value,
  className,
  name,
  rules,
  children,
  suffixIcon = null,
  formItem = true,
  options,
  label,
  ...rest
}) {
  const { labelInValue } = rest;
  const initialValue = !labelInValue ? { initialValue: value } : {};
  const selector = (
    <Select
      dropdownMatchSelectWidth={false}
      optionFilterProp="children"
      {...rest}
      style={{ width: '100%' }}
      suffixIcon={suffixIcon || <IconFlag vector={ICON.ICONS_CAP_DOWN} className="icon" />}
      disabled={!editMode}
      value={value}
    >
      {children ||
        options?.map((item) => (
          <Select.Option key={item.value} value={item.value}>
            {item.label}
          </Select.Option>
        ))}
    </Select>
  );
  const render = formItem ? (
    <Form.Item name={name} rules={rules} label={label} {...initialValue} >
      {selector}
    </Form.Item>
  ) : (
    selector
  );
  return <div className={`form-element editor-mode ${className}`}>{render}</div>;
}
